import React from 'react';
import { simTokens } from './tokens';

type SimTextProps = {
  children: React.ReactNode;
  className?: string;
};

export const SimLabel: React.FC<SimTextProps> = ({ children, className = '' }) => {
  return <p className={`${simTokens.label} ${className}`}>{children}</p>;
};

export const SimTitle: React.FC<SimTextProps> = ({ children, className = '' }) => {
  return <h1 className={`${simTokens.title} ${className}`}>{children}</h1>;
};

export const SimBody: React.FC<SimTextProps> = ({ children, className = '' }) => {
  return <p className={`${simTokens.body} ${className}`}>{children}</p>;
};
